import { generatePath } from 'react-router';
export var NUDGE_ROUTES = {
  root: '/nudges',
  single: '/nudges/:nudgeId',
  singleAnalytics: '/nudges/:nudgeId/analytics',
  new: '/nudges/new',
  newLoginFirstTime: '/nudges/new/log-in-first-time',
  newLoginAgain: '/nudges/new/log-in-again',
  newContent: '/nudges/new/content'
};
export function getNudgePath(_ref) {
  var id = _ref.id,
    _ref$showAnalytics = _ref.showAnalytics,
    showAnalytics = _ref$showAnalytics === void 0 ? false : _ref$showAnalytics;
  var basePath = showAnalytics ? NUDGE_ROUTES.singleAnalytics : NUDGE_ROUTES.single;
  return generatePath(basePath, {
    nudgeId: id
  });
}
export default getNudgePath;